import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';
import { initialAboutState } from '../../models/aboutModel';

export const fetchAbout = createAsyncThunk(
    'about/fetchAbout',
    async (_, thunkAPI) => {
        try {
            const response = await apiService('/Showcase/GetAllByAbout');
            if (response.isSuccess) {
                return response.result;
            } else {
                return thunkAPI.rejectWithValue(response.message || 'Hata oluştu');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const aboutSlice = createSlice({
    name: 'about',
    initialState: initialAboutState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAbout.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAbout.fulfilled, (state, action) => {
                state.loading = false;
                state.dataAbout = action.payload;
            })
            .addCase(fetchAbout.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default aboutSlice.reducer;
